export enum LocationType {
    CUSTOMER = 'customer',
    DEPOT = 'depot',
    VENDOR = 'vendor'
}
